module.exports = __webpack_public_path__ + "static/media/2_r_bondura_65.52_89.07.7b3e0d18.png";